module.exports = __webpack_public_path__ + "img/printable-cards-initial-logo.42fc392f.svg";